import { useNavigate } from 'react-router';
import { TableCell, TableRow } from '@mui/material';
import React from 'react';
import { fCurrency } from '../../../../utils/formatNumber';
import { fDate } from '../../../../utils/formatTime';
import Label from '../../../../components/Label';
import { PATH_ACCOUNT } from '../../../../routes/paths';

const WithdrawlReportTableRow = ({ row }) => {
  const {
    id,
    reference_number,
    created_date,
    sender,
    receiver,
    send_amount,
    status,
    cashback,
    stb_fee,
    receipt_amount,
    stb_earning,
    stb_loss,
    user_type,
  } = row;

  const navigate = useNavigate();

  return (
    <TableRow key={id}>
      <TableCell align="left" sx={{ whiteSpace: 'nowrap' }}>
        {fDate(created_date)}
      </TableCell>
      <TableCell align="left" sx={{ whiteSpace: 'nowrap' }}>
        {reference_number}
      </TableCell>
      <TableCell
        align="left"
        sx={{ whiteSpace: 'nowrap', cursor: 'pointer' }}
        onClick={() => navigate(PATH_ACCOUNT.retailUsers.profile(sender?.wallet_account_id, 'wallets'))}
      >
        {sender?.name}
      </TableCell>
      <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
        {user_type}
      </TableCell>
      <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
        {fCurrency(send_amount)}
      </TableCell>
      <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
        {fCurrency(stb_fee)}
      </TableCell>
      <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
        {fCurrency(stb_earning)}
      </TableCell>
      <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
        <Label color={(status === 'processed' && 'success') || 'error'} sx={{ textTransform: 'capitalize' }}>
          {status}
        </Label>
      </TableCell>
    </TableRow>
  );
};

export default WithdrawlReportTableRow;
